import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Avatar,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

export default function NewsCard({ article }) {
  const accent = article.color || "217.2 91.2% 59.8%";
        {console.log('article:',article)}

  return (
    <Card
      sx={{
        // 1. MUST fill the width of the sm={6} Grid item
        width: "100%",
        // 2. MUST stretch to match the tallest sibling in the row
        height: "100%",
        display: "flex",
        flexDirection: "column",
        borderRadius: 2,
        boxShadow: 2,
        cursor: "pointer",
        transition: "transform 0.18s ease, box-shadow 0.18s ease",
        "&:hover": { transform: "translateY(-4px)", boxShadow: 6 },
        border: "1px solid rgba(0,0,0,0.04)",
        overflow: "hidden",
        background: `linear-gradient(135deg, hsl(${accent}) / 0.03 0%, hsl(${accent}) / 0.01 100%)`,
      }}
      onClick={() => window.open(article.url, "_blank", "noopener,noreferrer")}
    >
      {/* top time and avatar */}
      <CardHeader
        // avatar={<Avatar sx={{ bgcolor: `hsl(${accent})` }} />}
        titleTypographyProps={{
          variant: "caption",
          color: "text.secondary",
          align: "right",
        }}
        title={article.time}
        sx={{
          borderBottom: "1px solid rgba(0,0,0,0.04)",
          px: 2,
          py: 1,
        }}
      />

      {/* image + content */}
      <CardContent
        sx={{
          // Allows content box to take up flexible space
          flex: 1,
          display: "flex",
          alignItems: "flex-start",
          gap: 2,
          px: 2,
          py: 2,
        }}
      >
       {article.image && article.image.trim() !== "" ? (
          <Box
            component="img"
            src={article.image}
            alt={article.title}
            onError={(e) => (e.target.src = "")} // handles broken images
            sx={{
              width: 72,
              height: 72,
              borderRadius: 1.5,
              objectFit: "cover",
              flexShrink: 0,
            }}
            loading="lazy"
          />
        ) : (
          <Box
            sx={{
              width: 72,
              height: 72,
              borderRadius: 1.5,
              flexShrink: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: (theme) => theme.palette.action.hover,
            }}
          >
            <OpenInNewIcon
              sx={{
                fontSize: 32,
                color: "text.secondary",
                opacity: 0.6,
              }}
            />
          </Box>
        )}

        <Box sx={{ flex: 1, minWidth: 0 }}>
          {/* title */}
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 600,
              fontSize: 16,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {article.title}
          </Typography>

          {/* summary */}
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              mt: 0.5,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
              lineHeight: 1.4,
            }}
          >
            {article.summary}
          </Typography>
        </Box>
      </CardContent>

      {/* footer */}
      <CardActions
        sx={{
          justifyContent: "space-between",
          px: 2,
          py: 1.25,
          borderTop: "1px solid rgba(0,0,0,0.06)",
          // mt: "auto" is CRITICAL to push footer to the bottom
          mt: "auto",
        }}
      >
        <Typography variant="caption" color="text.secondary">
          Click to read more
        </Typography>
        <IconButton
          size="small"
          aria-label="open"
          onClick={(e) => {
            e.stopPropagation();
            window.open(article.url, "_blank", "noopener,noreferrer");
          }}
        >
          <OpenInNewIcon fontSize="small" />
        </IconButton>
      </CardActions>
    </Card>
  );
}

NewsCard.propTypes = {
  article: PropTypes.shape({
    title: PropTypes.string.isRequired,
    summary: PropTypes.string,
    time: PropTypes.string,
    url: PropTypes.string,
    image: PropTypes.string,
    color: PropTypes.string,
  }).isRequired,
};
